import { trackLink, trackImpression } from 'lib/analytics/fpti'

const CONTACT_DETAIL_PAGE_GROUP = 'main:p2p:tab-contacts:activityDetail'
const CONTACT_DETAIL_PAGE_NAME = 'main:p2p:tab-contacts:activityDetail:node::'
const CONTACT_LIST_PAGE_GROUP = 'main:p2p:tab-contacts'
const CONTACT_LIST_PAGE_NAME = 'main:p2p:tab-contacts:node::'
const BLOCK_CONTACT_PAGE_GROUP = `${CONTACT_DETAIL_PAGE_GROUP}:contact_block_alert`
const BLOCK_CONTACT_PAGE_NAME = `${CONTACT_DETAIL_PAGE_NAME}:contact_block_alert`
const BLOCKED_CONTACTS_PAGE_GROUP = `${CONTACT_LIST_PAGE_GROUP}:blockedusers::`
const BLOCKED_CONTACTS_PAGE_NAME = `${CONTACT_LIST_PAGE_NAME}:blockedusers:`
const BLOCK_ERROR_PAGE_GROUP = `${CONTACT_DETAIL_PAGE_GROUP}:contact_blocked:`
const BLOCK_ERROR_PAGE_NAME = `${CONTACT_DETAIL_PAGE_NAME}:contact_blocked`

/**
 * Track block user click from contact details page
 **/
export function trackBlockContactClick() {
  trackLink(
    'block',
    CONTACT_DETAIL_PAGE_GROUP,
    CONTACT_DETAIL_PAGE_NAME,
    'link'
  )
}

/**
 * Track block user confirmation overpanel impression
 **/
export function trackBlockContactImpression() {
  trackImpression(BLOCK_CONTACT_PAGE_GROUP, BLOCK_CONTACT_PAGE_NAME)
}

/**
 * Track block user confirm button from block confirmation
 **/
export function trackBlockConfirmationClick() {
  trackLink('block', BLOCK_CONTACT_PAGE_GROUP, BLOCK_CONTACT_PAGE_NAME, 'link')
}

/**
 * Track block user cancel from block confirmation
 **/
export function trackBlockCancelClick() {
  trackLink('cancel', BLOCK_CONTACT_PAGE_GROUP, BLOCK_CONTACT_PAGE_NAME, 'link')
}

/**
 * Track blocked contact success overpanel impression
 **/
export function trackBlockContactSuccessImpression() {
  trackImpression(CONTACT_LIST_PAGE_GROUP, CONTACT_LIST_PAGE_NAME, {
    message_shown: 'contact_blocked',
  })
}

/**
 * Track blocked contacts link clicks from contact list
 **/
export function trackViewBlockedContactsLink() {
  trackLink(
    'blocked_users',
    BLOCKED_CONTACTS_PAGE_GROUP,
    BLOCKED_CONTACTS_PAGE_NAME,
    'link'
  )
}

/**
 * Track block user error overpanel
 **/
export function trackBlockedContactsImpression() {
  trackImpression(BLOCKED_CONTACTS_PAGE_GROUP, BLOCKED_CONTACTS_PAGE_NAME)
}

/**
 * Track unblock contact link
 **/
export function trackUnblockContactLink({ payerId }) {
  trackLink(
    'undo',
    BLOCKED_CONTACTS_PAGE_GROUP,
    BLOCKED_CONTACTS_PAGE_NAME,
    'link',
    { encr_rcvr_id: payerId }
  )
}

/**
 * Track unblocked contact success overpanel impression
 **/
export function trackUnblockContactSuccessImpression() {
  trackImpression(CONTACT_LIST_PAGE_GROUP, CONTACT_LIST_PAGE_NAME, {
    message_shown: 'contact_unblocked',
  })
}

/**
 * Track error message sending/requesting to/from a blocked contact
 **/
export function trackContactBlockedErrorImpression() {
  trackImpression(BLOCK_ERROR_PAGE_GROUP, BLOCK_ERROR_PAGE_NAME)
}
